import React, { useEffect, useRef } from "react";
import axios from "axios";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";

const ONLYOFFICE_API_SRC =
  "http://172.27.8.68:8081/web-apps/apps/api/documents/api.js";

const OnlyOfficeEditor = ({ showDocument, setShowDocument, document: doc, readOnly = false }) => {
  const editorRef = useRef(null);

  useEffect(() => {
    if (!showDocument || !doc?.id) return;

    const initEditor = async () => {
      if (editorRef.current) {
        try { editorRef.current.destroyEditor(); } catch (_) {}
      }

      // API builds the full config and signs the JWT at root level
      let config;
      try {
        const res = await axios.get(
          `/api/onlyoffice/config/${doc.id}?readOnly=${readOnly}`
        );
        config = res.data;
      } catch (err) {
        console.error("[OnlyOffice] Failed to load config", err.message);
        return;
      }

      editorRef.current = new window.DocsAPI.DocEditor(
        "onlyoffice-editor-container",
        config
      );
    };

    const scriptId = "onlyoffice-api-script";
    if (document.getElementById(scriptId)) {
      if (window.DocsAPI) initEditor();
    } else {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = ONLYOFFICE_API_SRC;
      script.onload = initEditor;
      document.head.appendChild(script);
    }

    return () => {
      if (editorRef.current) {
        try { editorRef.current.destroyEditor(); } catch (_) {}
        editorRef.current = null;
      }
    };
  }, [showDocument, doc?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Dialog
      open={showDocument}
      onClose={() => setShowDocument(false)}
      fullScreen
    >
      <DialogTitle sx={{ py: 1 }} className="text-primary">
        <Typography variant="h6" noWrap component="div" sx={{ mr: 5 }}>
          <AttachFileIcon sx={{ mb: 0.5, mr: 1 }} />
          {doc?.docName}
        </Typography>
        <IconButton
          aria-label="close"
          onClick={() => setShowDocument(false)}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <span className="material-icons">close</span>
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ p: 0, height: "100%" }}>
        <div
          key={doc?.id}
          id="onlyoffice-editor-container"
          style={{ height: "100%", width: "100%" }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default OnlyOfficeEditor;
